import { css } from '@emotion/react';

export const quillAlignment = css`
  .ql-align-right {
    text-align: right;
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-justify {
    text-align: justify;
  }
`;
